// extracted by mini-css-extract-plugin
export default {"searchContainer":"Search_searchContainer__DA0In","closeButton":"Search_closeButton__wJDKS"};